import React, { useContext, useState } from 'react';
import { Grid, InputLabel, Button } from '@material-ui/core';

import { postTCardCalendarNotes } from '../../../../../Core/Service/TCardDashboard-service';
import { SecondaryButton, TextBox } from '../../../../../Core/FormInput';
import { TCaredDashboardContext } from '../tCaredDashboard-Provider';
import AppContext from '../../../../../App/AppContext';

const TcardNotes = ({ note, tCardCalendarID }) => {
    const [state, setState] = useState({
        notes: note || '',
        isLoading: false
    });

    const { fetchData } = useContext(TCaredDashboardContext);
    const { showToast } = useContext(AppContext);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!state.notes?.trim()) return;

        try {
            setState((prev) => ({
                ...prev,
                isLoading: true
            }));

            const data = {
                tCardCalendarID: tCardCalendarID || '',
                note: state.notes
            };

            let res = await postTCardCalendarNotes(data);
            if (res.success) {
                setState((prev) => ({
                    ...prev,
                    notes: '',
                    isLoading: false
                }));
                fetchData();
                showToast(res.success);
            }
        } catch (error) {
            console.log(error);

            setState((prev) => ({
                ...prev,
                isLoading: false
            }));
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <InputLabel shrink error>
                        Notes
                    </InputLabel>

                    <TextBox
                        multiline
                        rows={5}
                        fullWidth
                        variant="outlined"
                        placeholder="Enter Notes"
                        name="notes"
                        value={state.notes}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <SecondaryButton type="submit" variant="contained" color="primary" disabled={state.isLoading} isBtnLoader={state.isLoading}>
                        {state.isLoading ? 'Saving...' : 'Save'}
                    </SecondaryButton>
                </Grid>
            </Grid>
        </form>
    );
};

export default TcardNotes;
